<script setup>
import {Dialog, DialogOverlay, DialogPanel, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {Icon} from "@iconify/vue";
import {useMainOrdersStore} from "@/stores/mainOrders.js";
import Checkbox from "@/components/Checkbox/index.vue";
import {useConfigStore} from "@/stores/config.js";
import Button from "@/components/Button/index.vue";
import {ref} from "vue";

const configStore = useConfigStore();
const ordersStore = useMainOrdersStore();
const emit = defineEmits(['closeModal', 'update']);
const props = defineProps({
  stores: Array,
})
const stores = ref(props.stores.length > 0 ? props.stores : [])

function closeModal() {
  emit('closeModal');
  ordersStore.close_stores_modal();
}

function save(){
  closeModal();
  emit('update', stores.value);
}
</script>

<template>
  <TransitionRoot appear show as="template">
    <Dialog as="div" @close="closeModal" class="relative z-[9999]">
      <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100"
          leave-to="opacity-0"
      >
        <DialogOverlay class="fixed inset-0 bg-[black]/60"/>
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex h-full overflow-hidden items-center justify-center px-4 py-8">
          <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
          >
            <DialogPanel
                class="w-full flex flex-col overflow-hidden rounded-md max-w-xl text-left align-middle shadow-xl transition-all bg-white dark:bg-black-800 text-black-600 dark:text-white max-h-[400px]"
            >
              <div class="flex flex-row justify-between px-4 border-b border-slate-700">
                <div class="text-lg font-semibold py-3">
                  Stores
                </div>
                <div class="flex flex-row items-center gap-4">
                  <button
                      type="button"
                      class="text-white-dark hover:text-red-500 outline-none"
                      @click="closeModal"
                  >
                    <Icon icon="pajamas:close-xs"/>
                  </button>
                </div>
              </div>
              <div class="p-5 flex-1 overflow-auto h-full flex flex-col gap-6">
                <div class="grid grid-cols-1 gap-5">
                  <div v-for="(store, i) in configStore.configs.stores" :key="'store-' + i"
                       class="flex items-center space-x-2">
                    <input
                        type="checkbox"
                        :id="'store-' + i"
                        :value="store.store"
                        v-model="stores"
                        class="form-checkbox h-5 w-5 text-blue-800 rounded border-gray-300 focus:outline-none focus:ring-0 focus:ring-transparent focus:ring-offset-0"
                    />
                    <label :for="'store-' + i" class="text-gray-700 dark:text-gray-200">
                      {{ store.store }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="p-4 border-t border-slate-700">
                <button class="btn btn-outline-dark p-1 w-full" @click="save">Save</button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<style scoped lang="scss">

</style>